




import { Component, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import store from '@/apps/open/store'

@Component
export default class DevCenter extends Vue {
  /* beforeRouteEnter (to: Route, from: Route, next: any) {
    if (store.getters['User/isRejectedDeveloper']) {
      next({ name: 'apply-developer', replace: true })
      return
    }
    next()
  } */
}
